import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <section className="mx-auto flex min-h-[70vh] max-w-7xl flex-col justify-center px-4 py-20 sm:px-6" data-testid="not-found-page">
      <Helmet>
        <title>Page not found | District Gaslight</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl font-black tracking-tighter sm:text-6xl">Page not found.</h1>
      <p className="mt-4 max-w-md text-neutral-600">The page you're looking for doesn't exist. Try the menu or head home.</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/shop-all" className="btn-lime" data-testid="not-found-shop-button">Shop the menu</Link>
        <Link to="/" className="btn-outline" data-testid="not-found-home-button">Home</Link>
      </div>
    </section>
  );
}
